import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";
import { toast } from "sonner";
import { Phone, PhoneCall, Info } from "lucide-react";

export const Dialer = ({ open, onClose }) => {
  const [contacts, setContacts] = useState([]);
  const [number, setNumber] = useState("");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (open) api.get("/contacts").then((r) => setContacts(r.data)).catch(() => {});
  }, [open]);

  const placeCall = async (name, phone) => {
    if (!phone) return toast.error("Enter a number to call");
    try {
      await api.post("/call_logs", { contact_name: name || "Manual dial", number: phone, note, direction: "outbound", status: "placed", placed_at: new Date().toISOString() });
    } catch (err) {
      if (err?.response?.status !== 403) console.warn("call log create failed:", err?.message || err);
    }
    window.open(`tel:${phone.replace(/[^0-9+]/g, "")}`, "_self");
    toast.success(`Dialing ${phone} via Intermedia Unite`);
    setNote("");
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="dialer-modal">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2"><PhoneCall className="w-5 h-5 text-pink-700" /> Intermedia Unite Dialer</DialogTitle>
        </DialogHeader>
        <div className="flex items-start gap-2 text-xs text-sky-700 bg-sky-50 border border-sky-200 rounded-lg p-2.5">
          <Info className="w-4 h-4 mt-0.5 shrink-0" />
          <span>Click-to-call placeholder. Launches your device dialer and logs the call. Live Intermedia Unite API wiring can be enabled once credentials are provided.</span>
        </div>
        <div className="space-y-2">
          <div className="flex gap-2">
            <Input data-testid="dialer-number-input" value={number} onChange={(e) => setNumber(e.target.value)} placeholder="Enter phone number" className="font-mono" />
            <Button data-testid="dialer-call-button" onClick={() => placeCall("", number)} className="bg-pink-700 hover:bg-pink-800 gap-1.5"><Phone className="w-4 h-4" /> Call</Button>
          </div>
          <Input data-testid="dialer-note-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Quick note (patient / prescriber)" />
        </div>
        <div className="mt-1">
          <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Preset contacts</div>
          <div className="space-y-1.5 max-h-52 overflow-y-auto">
            {contacts.map((c) => (
              <button key={c.id} data-testid={`dialer-contact-${c.id}`} onClick={() => placeCall(c.name, c.phone)}
                className="w-full flex items-center justify-between px-3 py-2 rounded-lg border border-slate-200 hover:border-pink-300 hover:bg-pink-50 text-left">
                <div>
                  <div className="text-sm font-medium text-slate-800">{c.name}</div>
                  <div className="text-xs text-slate-500">{c.category}</div>
                </div>
                <span className="font-mono text-xs text-pink-800">{c.phone}</span>
              </button>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
